import { Noun } from "@/data/noun/types";
import { ComponentProps, ReactNode } from "react";
import { LinkShallow } from "./ui/link";
import { cn } from "@/utils/shadcn";

interface NounDialogTriggerProps
  extends Omit<ComponentProps<typeof LinkShallow>, "searchParam"> {
  noun: Noun;
  children: ReactNode;
}

export default function NounDialogTrigger({
  noun,
  children,
  className,
  ...props
}: NounDialogTriggerProps) {
  return (
    <LinkShallow
      searchParam={{ name: "lilnounId", value: noun.id }}
      className={cn("hover:cursor-pointer enabled:active:scale-100", className)}
      {...props}
    >
      {children}
    </LinkShallow>
  );
}
